import React, { useEffect, useState } from "react";
import { api } from "../../api";
import { showError, showInfo } from "../../utils/toast";
import "../../sass/components/projetoFluxoChamado.scss";

const norm = (valor) => (valor == null ? "" : String(valor).trim());

const normalizarTecnicos = (payload) => {
  const lista = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
      ? payload.data
      : [];

  return lista
    .map((item) =>
      norm(item?.Nome ?? item?.nome ?? item?.RazaoSocial ?? item?.Usuario),
    )
    .filter(Boolean)
    .filter((item, index, arr) => arr.indexOf(item) === index)
    .sort((a, b) => a.localeCompare(b, "pt-BR"));
};

const ModalEncaminharSuporte = ({
  isOpen,
  onClose,
  projeto,
  funcionario,
  codFunc,
  autorId,
  onSuccess,
}) => {
  const [tecnicos, setTecnicos] = useState([]);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState("");
  const [form, setForm] = useState({
    resumoSolucao: "",
    versaoLiberada: "",
    orientacaoSuporte: "",
    tecnicoSuporte: "",
  });

  const idProjeto = Number(projeto?.ID_PROJETO ?? projeto?.id ?? 0);

  useEffect(() => {
    if (!isOpen) return;
    setForm({
      resumoSolucao: "",
      versaoLiberada: "",
      orientacaoSuporte:
        "Entrar em contato com o cliente, informar a correção e solicitar a validação do processo.",
      tecnicoSuporte: "",
    });
    setErro("");
  }, [isOpen, idProjeto]);

  useEffect(() => {
    if (!isOpen) return;
    let ativo = true;

    api
      .get("/func/setor/SUPORTE", {
        params: { situacao: "Ativo", bloqueado: 0 },
      })
      .then(({ data }) => {
        if (ativo) setTecnicos(normalizarTecnicos(data));
      })
      .catch(() => {
        if (ativo) setTecnicos([]);
      });

    return () => {
      ativo = false;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const alterar = (campo, valor) => {
    setForm((prev) => ({ ...prev, [campo]: valor }));
    setErro("");
  };

  const enviar = async (event) => {
    event.preventDefault();
    if (enviando) return;

    if (!norm(form.resumoSolucao)) {
      setErro("Informe o resumo da solução implementada.");
      return;
    }

    if (!norm(form.orientacaoSuporte)) {
      setErro("Informe a orientação para o suporte.");
      return;
    }

    setEnviando(true);

    try {
      const { data } = await api.post(
        `/projetos/${idProjeto}/encaminhar-suporte`,
        {
          resumoSolucao: norm(form.resumoSolucao),
          versaoLiberada: norm(form.versaoLiberada) || null,
          orientacaoSuporte: norm(form.orientacaoSuporte),
          tecnicoSuporte: norm(form.tecnicoSuporte),
          funcionario: norm(funcionario),
          codFunc: norm(codFunc),
          autorId: Number(autorId) || Number(codFunc) || 0,
        },
      );

      showInfo(data?.message || "Projeto encaminhado ao suporte.");
      await onSuccess?.(data);
      onClose?.();
    } catch (error) {
      const mensagem =
        error?.response?.data?.message ||
        error?.message ||
        "Falha ao encaminhar o projeto ao suporte.";
      setErro(mensagem);
      showError(mensagem);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="pfc-modal-backdrop" onMouseDown={onClose}>
      <section
        className="pfc-modal"
        role="dialog"
        aria-modal="true"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header>
          <div>
            <span>Retorno operacional</span>
            <h2>Encaminhar projeto ao suporte</h2>
            <p>
              Projeto {projeto?.CODIGO || `#${idProjeto}`} · Chamado de origem #
              {projeto?.ID_CHAMADO_ORIGEM}
            </p>
          </div>
          <button type="button" onClick={onClose} disabled={enviando}>
            ×
          </button>
        </header>

        <form onSubmit={enviar}>
          <div className="pfc-modal-alert">
            Será criado um novo chamado na fila do suporte. O projeto passará
            para <strong>AGUARDANDO RETORNO DO CLIENTE</strong>.
          </div>

          <label>
            <span>Resumo da solução *</span>
            <textarea
              rows={4}
              value={form.resumoSolucao}
              onChange={(event) =>
                alterar("resumoSolucao", event.target.value)
              }
              placeholder="Descreva objetivamente o que foi corrigido."
            />
          </label>

          <div className="pfc-modal-grid">
            <label>
              <span>Versão liberada</span>
              <input
                value={form.versaoLiberada}
                onChange={(event) =>
                  alterar("versaoLiberada", event.target.value)
                }
                placeholder="Ex.: 3.0.145"
              />
            </label>

            <label>
              <span>Técnico do suporte</span>
              <select
                value={form.tecnicoSuporte}
                onChange={(event) =>
                  alterar("tecnicoSuporte", event.target.value)
                }
              >
                <option value="">Fila geral do suporte</option>
                {tecnicos.map((tecnico) => (
                  <option key={tecnico} value={tecnico}>
                    {tecnico}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <label>
            <span>Orientação para o suporte *</span>
            <textarea
              rows={4}
              value={form.orientacaoSuporte}
              onChange={(event) =>
                alterar("orientacaoSuporte", event.target.value)
              }
            />
          </label>

          {erro ? <div className="pfc-modal-error">{erro}</div> : null}

          <footer>
            <button
              type="button"
              className="secondary"
              onClick={onClose}
              disabled={enviando}
            >
              Cancelar
            </button>
            <button type="submit" className="primary" disabled={enviando}>
              {enviando ? "Encaminhando..." : "Criar chamado de retorno"}
            </button>
          </footer>
        </form>
      </section>
    </div>
  );
};

export default ModalEncaminharSuporte;
